import PropertyImg_1 from "../../../images/search-result/property-img-1.jpg";
import PropertyImg_1_768 from "../../../images/search-result/property-img-1_768.jpg";
import PropertyImg_1_1400 from "../../../images/search-result/property-img-1_1400.jpg";
import PropertyImg_1_1600 from "../../../images/search-result/property-img-1_1600.jpg";
import PropertyImg_2 from "../../../images/search-result/property-img-2.jpg";
import PropertyImg_2_768 from "../../../images/search-result/property-img-2_768.jpg";
import PropertyImg_2_1400 from "../../../images/search-result/property-img-2_1400.jpg";
import PropertyImg_2_1600 from "../../../images/search-result/property-img-2_1600.jpg";
import PropertyImg_3 from "../../../images/search-result/property-img-3.jpg";
import PropertyImg_3_768 from "../../../images/search-result/property-img-3_768.jpg";
import PropertyImg_3_1400 from "../../../images/search-result/property-img-3_1400.jpg";
import PropertyImg_3_1600 from "../../../images/search-result/property-img-3_1600.jpg";
import PropertyImg_4 from "../../../images/search-result/property-img-4.jpg";
import PropertyImg_4_768 from "../../../images/search-result/property-img-4_768.jpg";
import PropertyImg_4_1400 from "../../../images/search-result/property-img-4_1400.jpg";
import PropertyImg_4_1600 from "../../../images/search-result/property-img-4_1600.jpg";
export const PropertyList = [
    {
        PropertyImg: PropertyImg_1,
        PropertyImg768: PropertyImg_1_768,
        PropertyImg1400: PropertyImg_1_1400,
        PropertyImg1600: PropertyImg_1_1600,
        PropertyTag: 'New Instruction', 
        PropertyTitle: 'Front Lane, Upminster, RM14',
        PropertyText: '3 bedroom property for sale',
        PropertyPrice: '£2,500,000',
        PropertyInfo:'This stunning 2 bedroom property for sale ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque facilisis rhoncus dolor at varius. Sed rutrum risus ac lobortis suscipit.',
        BranchName: 'Upminster Branch',
        AgentNumber: '01708259539',
        BtnText:'View Details',
        BookView:'Book a viewing'
    },
    {
        PropertyImg: PropertyImg_2,
        PropertyImg768: PropertyImg_2_768,
        PropertyImg1400: PropertyImg_2_1400,
        PropertyImg1600: PropertyImg_2_1600,
        PropertyTag: 'Under offer', 
        PropertyTitle: 'Freeman Way, Emerson Park, RM11',
        PropertyText: '3 bedroom property for sale',
        PropertyPrice: '£2,450,000',
        PropertyInfo:'This stunning 2 bedroom property for sale ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque facilisis rhoncus dolor at varius. Sed rutrum risus ac lobortis suscipit.',
        BranchName: 'Upminster Branch',
        AgentNumber: '01708259539',
        BtnText:'View Details',
        BookView:'Book a viewing'
    },
    {
        PropertyImg: PropertyImg_3,
        PropertyImg768: PropertyImg_3_768,
        PropertyImg1400: PropertyImg_3_1400,
        PropertyImg1600: PropertyImg_3_1600,
        PropertyTag: 'New Instruction', 
        PropertyTitle: 'Ernest Road, Emerson Park, RM11',
        PropertyText: '3 bedroom property for sale',
        PropertyPrice: '£2,350,000',
        PropertyInfo:'This stunning 2 bedroom property for sale ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque facilisis rhoncus...',
        BranchName: 'Upminster Branch',
        AgentNumber: '01708259539',
        BtnText:'View Details',
        BookView:'Book a viewing'
    },
    {
        PropertyImg: PropertyImg_4,
        PropertyImg768: PropertyImg_4_768,
        PropertyImg1400: PropertyImg_4_1400,
        PropertyImg1600: PropertyImg_4_1600,
        PropertyTag: 'For sale', 
        PropertyTitle: 'Ayloffs Walk, Emerson Park, RM11',
        PropertyText: '3 bedroom property for sale',
        PropertyPrice: '£1,650,000',
        PropertyInfo:'This stunning 2 bedroom property for sale ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque facilisis rhoncus...',
        BranchName: 'Upminster Branch',
        AgentNumber: '01708259539',
        BtnText:'View Details',
        BookView:'Book a viewing'
    },
    {
        PropertyImg: PropertyImg_1,
        PropertyImg768: PropertyImg_1_768,
        PropertyImg1400: PropertyImg_1_1400,
        PropertyImg1600: PropertyImg_1_1600,
        PropertyTag: 'For sale', 
        PropertyTitle: 'Ayloffs Walk, Emerson Park, RM11',
        PropertyText: '3 bedroom property for sale',
        PropertyPrice: '£1,650,000',
        PropertyInfo:'This stunning 2 bedroom property for sale ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque facilisis rhoncus...',
        BranchName: 'Upminster Branch',
        AgentNumber: '01708259539',
        BtnText:'View Details',
        BookView:'Book a viewing'
    },
]